<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'rbv-hotel-rfp-bid-manager-upload-responses-action-report',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Upload Successful',
          'NOT_FOUND': 'Upload Failed - Bid Deleted',
          'STATUS_CHANGED': 'Upload Failed - Bid Changed',
          'ERROR': 'Upload Failed - Unable to match Bid with Response'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? "Response upload failed!" : "Response upload for some bids have failed!" },
      message () {
        return this.items.length === 1
          ? "We were not able to upload response to a bid because of the reason listed below:"
          : `${this.items.length - this.failures} of ${this.items.length} bids responses were successfully uploaded.<br /> We were not able to upload responses to all bids because of the reasons listed below:`
      }
    }
  }
</script>
